import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ApiCallService } from '../../../Services/api-call-service.service';

interface TopWinner {
  userName: string;
  score: number;
}

@Component({
  selector: 'app-top-winners',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './top-winners.component.html',
  styleUrl: './top-winners.component.scss',
})
export class TopWinnersComponent implements OnInit, OnDestroy {
  winners: TopWinner[] = [];
  // list is doubled so the marquee loops without a gap (animation moves -50%)
  tickerItems: TopWinner[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private apiCall: ApiCallService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.apiCall
      .GetCallWithoutToken('Public/GetTopWinners')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const list = response?.responseCode === 200 ? response.data : [];
          // the stored procedure returns UserName/Score, accept either casing
          this.winners = (Array.isArray(list) ? list : []).map((w: any) => ({
            userName: w.userName ?? w.UserName ?? '',
            score: Number(w.score ?? w.Score ?? 0),
          }));
          this.tickerItems = [...this.winners, ...this.winners];
          this.cdr.markForCheck();
        },
        error: () => {
          this.winners = [];
          this.tickerItems = [];
          this.cdr.markForCheck();
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
